// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
    height: 5rem;
    width: 100vw;
    /* padding: 10px; */
    /* position: fixed; */
    top: 0;
    left: 0;
    z-index: 99;
    background-color: var(--color-primary-white);
    display: grid;
    place-items: center;
    align-items: center;
    border-bottom: 1px solid var(--color-border-nav);
    position: sticky;
}

.styles_container__AuAjA {
    width: var(--container-width-md);
    max-width: 1920px;
    margin-inline: auto ;
}

.styles_navLeft__1piMp {
    width: 35%;
    place-items: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.styles_navRight__a5ZmH {
    width: 65%;
    place-items: center;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}


.styles_navbarToggleBtn__EDt9d {
    display: none;
    
}

.styles_navbarContainer__G48CB {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}

.styles_logo__XJMgc {
    width: 24px;
    height: 80px;
    cursor: pointer;
}

.styles_navbarLinks__aW-yA{
    display: flex;
    gap: 48px;
    align-items: center;
    list-style: none;
}
.styles_navbarLinks__aW-yA a {
    transition: var(--transition);
}
.styles_navbarLinks__aW-yA a:hover {
    color: var(--color-primary-black);
}

.styles_active-nav__xnM2f {
    position: relative;
}

.styles_active-nav__xnM2f::after {
    content: '';
    display: block;
}

.styles_authBtnLogin__JcCIP {
    width: 109px;
    height: 40px;
    border-radius: 8px;
    font-size: 18px;
    font-weight: 500;
    font-family: 'Brandon Grotesque';
    cursor: pointer;
    background: linear-gradient(90deg, var(--color-primary) 0%, var(--color-secundary) 100%);
    color: var(--color-primary-white);
    margin-left: 50px;

}

.styles_authBtnGetStarted__KDF2u {
    width: 140px;
    height: 40px;
    border-radius: 8px;
    font-size: 18px;
    font-weight: 500;
    font-family: 'Brandon Grotesque';
    cursor: pointer;
    background: linear-gradient(90deg, var(--color-primary) 0%, var(--color-secundary) 100%);
    color: var(--color-primary-white);

}

.styles_searchGlass__k2FDt {
    cursor: pointer;
}


/*medium and small screens */
@media screen and (max-width: 1280px ) {
    .styles_navbarToggleBtn__EDt9d {
        display: inline-block;
        background: transparent;
        font-size: 18px;
        cursor: pointer;
    }

    .styles_navbarToggleBtn__EDt9d svg {
        display: var(--color-black);
    }

    .styles_navRight__a5ZmH{
        position: absolute;
        display: flex;
        top: 100%;
        right: 0;
        flex-direction: column;
        align-items: flex-end;
    }

    .styles_navbarLinks__aW-yA{
        flex-direction: column;
        gap: 0;
        align-items: flex-end;
    }

    .styles_active-nav__xnM2f .styles_active-nav__xnM2f::after {
        display: none;
    }

    .styles_navbarShow__ZpfrJ {
        display: flex;
        top: 56px;
        height: auto;
        row-gap: 8px;
        padding-bottom: 10px;
        background: var(--color-primary-white);
    
    }

    .styles_navbarHide__8rc3L {
        display: none;
    }


}`, "",{"version":3,"sources":["webpack://./src/components/Navbar/styles.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,MAAM;IACN,OAAO;IACP,WAAW;IACX,4CAA4C;IAC5C,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gDAAgD;IAChD,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;;AAGA;IACI,aAAa;;AAEjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,wFAAwF;IACxF,iCAAiC;IACjC,iBAAiB;;AAErB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,wFAAwF;IACxF,iCAAiC;;AAErC;;AAEA;IACI,eAAe;AACnB;;;AAGA,4BAA4B;AAC5B;IACI;QACI,qBAAqB;QACrB,uBAAuB;QACvB,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,SAAS;QACT,QAAQ;QACR,sBAAsB;QACtB,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;QACtB,MAAM;QACN,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,SAAS;QACT,YAAY;QACZ,YAAY;QACZ,oBAAoB;QACpB,sCAAsC;;IAE1C;;IAEA;QACI,aAAa;IACjB;;;AAGJ","sourcesContent":["nav {\n    height: 5rem;\n    width: 100vw;\n    /* padding: 10px; */\n    /* position: fixed; */\n    top: 0;\n    left: 0;\n    z-index: 99;\n    background-color: var(--color-primary-white);\n    display: grid;\n    place-items: center;\n    align-items: center;\n    border-bottom: 1px solid var(--color-border-nav);\n    position: sticky;\n}\n\n.container {\n    width: var(--container-width-md);\n    max-width: 1920px;\n    margin-inline: auto ;\n}\n\n.navLeft {\n    width: 35%;\n    place-items: center;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.navRight {\n    width: 65%;\n    place-items: center;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n}\n\n\n.navbarToggleBtn {\n    display: none;\n    \n}\n\n.navbarContainer {\n    height: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n}\n\n.logo {\n    width: 24px;\n    height: 80px;\n    cursor: pointer;\n}\n\n.navbarLinks{\n    display: flex;\n    gap: 48px;\n    align-items: center;\n    list-style: none;\n}\n.navbarLinks a {\n    transition: var(--transition);\n}\n.navbarLinks a:hover {\n    color: var(--color-primary-black);\n}\n\n.active-nav {\n    position: relative;\n}\n\n.active-nav::after {\n    content: '';\n    display: block;\n}\n\n.authBtnLogin {\n    width: 109px;\n    height: 40px;\n    border-radius: 8px;\n    font-size: 18px;\n    font-weight: 500;\n    font-family: 'Brandon Grotesque';\n    cursor: pointer;\n    background: linear-gradient(90deg, var(--color-primary) 0%, var(--color-secundary) 100%);\n    color: var(--color-primary-white);\n    margin-left: 50px;\n\n}\n\n.authBtnGetStarted {\n    width: 140px;\n    height: 40px;\n    border-radius: 8px;\n    font-size: 18px;\n    font-weight: 500;\n    font-family: 'Brandon Grotesque';\n    cursor: pointer;\n    background: linear-gradient(90deg, var(--color-primary) 0%, var(--color-secundary) 100%);\n    color: var(--color-primary-white);\n\n}\n\n.searchGlass {\n    cursor: pointer;\n}\n\n\n/*medium and small screens */\n@media screen and (max-width: 1280px ) {\n    .navbarToggleBtn {\n        display: inline-block;\n        background: transparent;\n        font-size: 18px;\n        cursor: pointer;\n    }\n\n    .navbarToggleBtn svg {\n        display: var(--color-black);\n    }\n\n    .navRight{\n        position: absolute;\n        display: flex;\n        top: 100%;\n        right: 0;\n        flex-direction: column;\n        align-items: flex-end;\n    }\n\n    .navbarLinks{\n        flex-direction: column;\n        gap: 0;\n        align-items: flex-end;\n    }\n\n    .active-nav .active-nav::after {\n        display: none;\n    }\n\n    .navbarShow {\n        display: flex;\n        top: 56px;\n        height: auto;\n        row-gap: 8px;\n        padding-bottom: 10px;\n        background: var(--color-primary-white);\n    \n    }\n\n    .navbarHide {\n        display: none;\n    }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__AuAjA`,
	"navLeft": `styles_navLeft__1piMp`,
	"navRight": `styles_navRight__a5ZmH`,
	"navbarToggleBtn": `styles_navbarToggleBtn__EDt9d`,
	"navbarContainer": `styles_navbarContainer__G48CB`,
	"logo": `styles_logo__XJMgc`,
	"navbarLinks": `styles_navbarLinks__aW-yA`,
	"active-nav": `styles_active-nav__xnM2f`,
	"authBtnLogin": `styles_authBtnLogin__JcCIP`,
	"authBtnGetStarted": `styles_authBtnGetStarted__KDF2u`,
	"searchGlass": `styles_searchGlass__k2FDt`,
	"navbarShow": `styles_navbarShow__ZpfrJ`,
	"navbarHide": `styles_navbarHide__8rc3L`
};
export default ___CSS_LOADER_EXPORT___;
